export default "__VITE_ASSET__d677246e__"